var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPriceTag = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mobile-start",
  transform: "translate(-178.000000, -3811.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Browse",
  transform: "translate(-97.000000, 3783.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Budicon-Solid/Ecommerce/price-tag",
  transform: "translate(275.000000, 28.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M19.7395269,-4.52530952e-14 L11.6873709,-4.52530952e-14 C11.3530558,-0.00078010795 11.032307,0.132146924 10.7965509,0.369183444 L0.369126928,10.7977834 C0.132784767,11.0340171 0,11.3544839 0,11.6886454 C0,12.022807 0.132784767,12.3432738 0.369126928,12.5795074 L8.42128293,20.6316634 C8.91366708,21.1227676 9.71062278,21.1227676 10.2030069,20.6316634 L20.6308509,10.2030634 C20.8677233,9.96720381 21.0004663,9.64643088 20.9995319,9.31215944 L20.9995319,1.26000344 C20.9987862,0.564431723 20.4350986,0.000744203082 19.7395269,-4.52530952e-14 Z M15.5395269,7.56000344 C14.379729,7.56000344 13.4395269,6.61980142 13.4395269,5.46000344 C13.4395269,4.30020547 14.379729,3.36000344 15.5395269,3.36000344 C16.6993249,3.36000344 17.6395269,4.30020547 17.6395269,5.46000344 C17.6395269,6.61980142 16.6993249,7.56000344 15.5395269,7.56000344 Z",
  id: "Shape",
  fill: "currentColor",
  fillRule: "nonzero"
}))))))));
export default SvgPriceTag;